export const MODULE_NAMESPACE = 'prebookingAttract';
export const NOOP = () => undefined;
